<div class="container-dash">
    <div class="row-dash">
        <app-dashboard-navbar></app-dashboard-navbar>
        <div class="main">
            <header>
                <div class="card">
                    <div class="card-header">
                        Enlazar redes sociales
                    </div>
                    <div class="card-body">
                        <section id="social-media-accounts" class="social-media-accounts">
                            <div class="container text-center">
                                <div class="row">
                                    <div class="col-lg-12 col-md-6 mb-lg-0 mb-5">
                                        <div class="avatar mx-auto">
                                            <img src="../../../assets/images/twitter.png" class="z-depth-1"
                                            alt="Sample avatar" height="50" width="50">
                                        </div>
                                        <h5 class="font-weight-bold mt-4 mb-3">Twitter</h5>
                                        <div *ngIf="LoggedTwitter">
                                            <p>Cuenta vinculada correctamente</p>
                                            <button type="button" (click)="unlinkTwitter()" class="btn btn-primary">Desvincular cuenta</button>
                                        </div>
                                        <div *ngIf="!LoggedTwitter">
                                            <button type="button" (click)="loginTwitter()" class="btn btn-primary">Vincular cuenta</button>
                                        </div>
                                        <div *ngIf="unlinkError" class="alert alert-danger" role="alert"> 
                                            Error al intentar desvincular la cuenta
                                        </div>
                                    </div>  
                                </div>
                            </div>
                        </section>
                    </div>
                  </div>
            </header>
        </div>
    </div>
</div>
<app-footer></app-footer>